export const resnetClasses: {[id: number]: string[]} = {
    '0': ['n01440764', 'bike'],
    '1': ['n01443537', 'car'],
    '2': ['n01484850', 'cat'],
    '3': ['n01491361', 'dog'],
    '4': ['n01494475', 'flower'],
    '5': ['n01496331', 'horse'],
    '6': ['n01498041', 'human'],
  };
  